/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import { cssMap, jsx } from '@atlaskit/css';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const styles = cssMap({
	wrapper: {
		width: '50%',
		paddingInline: token('space.150'),
		paddingBlock: token('space.100'),
		position: 'relative',
		borderRadius: '1rem',
		backgroundColor: token('color.background.input'),
		boxShadow: token('elevation.shadow.overlay'),
	},

	message: {
		color: token('color.text'),
	},
});

type WarningView = {
	onKeep: () => void;
	onDelete: () => void;
	willDeleteAfterAbort: boolean;
};

export const WarningView = ({ onKeep, onDelete, willDeleteAfterAbort }: WarningView) => {
	const { formatMessage } = useIntl();

	return (
		<Inline spread="space-between" alignBlock="center" space="space.100">
			<Inline space="space.100" alignBlock="center" xcss={styles.message}>
				<StatusWarningIcon
					color={token('color.icon.warning')}
					spacing="spacious"
					size="medium"
					label=""
				/>
				{formatMessage(willDeleteAfterAbort ? messages.deleteMessage : messages.stopMessage)}
			</Inline>
			<Inline space="space.100">
				<Button appearance="subtle" onClick={onKeep}>
					{formatMessage(willDeleteAfterAbort ? messages.keepButtonLabel : messages.noButtonLabel)}
				</Button>
				<Button appearance={willDeleteAfterAbort ? 'warning' : 'default'} onClick={onDelete}>
					{formatMessage(
						willDeleteAfterAbort ? messages.deleteButtonLabel : messages.yesButtonLabel,
					)}
				</Button>
			</Inline>
		</Inline>
	);
};
